/**
 * @generated SignedSource<<20c7afcf273c627ead4c84b7f7cd1eea>>
 * @relayHash 70356eddfe31107d34b9ed15e413b7e7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID caf3fb50738d7b54c996532e810d7773bee998d1900da6918ed70ae31326ebec

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalSidebarAggQuery$variables = {
  containerId: string;
  isCombinedAggQueryEnabled: boolean;
  searchQuery: string;
};
export type GoalSidebarAggQuery$data = {
  readonly townsquare: {
    readonly goalTql?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"GoalSidebarAgg">;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};
export type GoalSidebarAggQuery = {
  response: GoalSidebarAggQuery$data;
  variables: GoalSidebarAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isCombinedAggQueryEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v3 = [
  {
    "kind": "Variable",
    "name": "containerId",
    "variableName": "containerId"
  },
  {
    "kind": "Variable",
    "name": "q",
    "variableName": "searchQuery"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "start"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalSidebarAggQuery",
    "selections": [
      {
        "concreteType": "TownsquareQueryApi",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "condition": "isCombinedAggQueryEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v3/*: any*/),
                "concreteType": "TownsquareGoalConnection",
                "kind": "LinkedField",
                "name": "goalTql",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "FragmentSpread",
                            "name": "GoalSidebarAgg"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalSidebarAggQuery",
    "selections": [
      {
        "concreteType": "TownsquareQueryApi",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "condition": "isCombinedAggQueryEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v3/*: any*/),
                "concreteType": "TownsquareGoalConnection",
                "kind": "LinkedField",
                "name": "goalTql",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "key"
                          },
                          {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "canAddWatchers"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canAddLinkedGoals"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canRemoveLinkedGoals"
                              },
                              {
                                "concreteType": "TownsquareGoalAppCapabilities",
                                "kind": "LinkedField",
                                "name": "apps",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "canCreateGoal"
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canManageOwnership"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canAddTeams"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canRemoveTeams"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canEditStartDate"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canEditMetrics"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canAddLinkedFocusAreas"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canRemoveLinkedFocusAreas"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canEditCustomFields"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canAddTags"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canRemoveTags"
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v4/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "watchers",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "count"
                              },
                              {
                                "concreteType": "TownsquareUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v4/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "name"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "startDate"
                          },
                          {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "targetDate",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareTargetDateRange",
                                "kind": "LinkedField",
                                "name": "dateRange",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "end"
                                  },
                                  (v6/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetricTargetPeriodConnection",
                                        "kind": "LinkedField",
                                        "name": "metricTargetPeriods",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricTargetPeriod",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "date",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareTargetDateRange",
                                                        "kind": "LinkedField",
                                                        "name": "dateRange",
                                                        "plural": false,
                                                        "selections": [
                                                          (v6/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                  },
                                                  (v5/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v4/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "caf3fb50738d7b54c996532e810d7773bee998d1900da6918ed70ae31326ebec",
    "metadata": {},
    "name": "GoalSidebarAggQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "55be154d735d6ecd765f5644c82203ad";

export default node;
